import React from 'react';
import { usePlan } from '../../contexts/PlanContext';
import { useNotification } from '../../contexts/NotificationContext';

/**
 * <ComingSoonOverlay section="integrations">
 *   <IntegrationsPanel />
 * </ComingSoonOverlay>
 *
 * Admin-controlled, platform-wide "coming soon" switch — different from
 * <LockedFeature>, which hides content behind an upgrade wall. Here the
 * section stays fully visible and browsable; a transparent layer just
 * catches every click and shows a toast instead of letting the real
 * action run underneath.
 */
const ComingSoonOverlay = ({ section, children }) => {
  const { isSectionDisabled } = usePlan();
  const { toast } = useNotification();

  if (!isSectionDisabled(section)) return children;

  return (
    <div style={{ position: 'relative' }}>
      {children}
      <div
        data-testid={`coming-soon-overlay-${section}`}
        onClick={() => toast.success('Muy pronto')}
        style={{ position: 'absolute', inset: 0, cursor: 'not-allowed', zIndex: 10 }}
      />
    </div>
  );
};

export default ComingSoonOverlay;
